// Module
var code = "<div class=\"mycrm-mini-toggle\"> <switch class=\"info xs\" ng-model=\"vm.value\" ng-change=\"vm.onChange({ value: vm.value })\" disabled=\"vm.disabled\"></switch> </div> ";
// Exports
module.exports = code;